import React from "react";
import DataSummaryTable from "../components/table/DataSummaryTable";
import { useGetCoverageSpreadsQuery } from "../redux/service/modules/dashboard";
import { useSelector } from "react-redux";
import { useLazyGetLazyCoverageSpreadsQuery } from "../redux/service/modules/dashboard/lazzyQuery";

const CoverageSpreadTable = ({ filters }) => {
    const dateRange = useSelector((state) => state.date);
    const [exportToExcelQuery] = useLazyGetLazyCoverageSpreadsQuery();
    console.log(filters);
    return (
        <DataSummaryTable
            title="Coverage Spread"
            initialDateRange={dateRange}
            queryHook={useGetCoverageSpreadsQuery}
            maxRows={6}
            filters={filters}
            exportToExcelQuery={exportToExcelQuery}
        />
    );
};

export default CoverageSpreadTable;
